
    <ng-container [formGroup]="audianceMonitor">
      <div class="paybee-modal-header pb-1 flex-column" style="border-bottom: 1px solid #DFDFDF;">
        @if(activeScreen == 'monitorsList'){
          <div class="modal-main-heading">Audience Monitor(s)</div>
          <div class="modal-sub-heading">Create or update Audience Monitor(s).</div>
        }  @else if(activeScreen == 'createMonitor'){
          <div class="modal-main-heading">Create New Audience Monitor</div>
          <div class="modal-sub-heading">Create a new Audience Monitor for your event.</div>
        } @else if(activeScreen == 'updateMonitor'){
          <div class="modal-main-heading">Update Audience Monitor</div>
        }
       
      </div>
        <div class="modal-body custom-material-form updated-dropdown pt-1" >
          @if(activeScreen == 'monitorsList'){
                <ng-container *ngIf='monitorsList'>
                <div class="d-flex justify-content-between align-items-center mb-4 mt-3"> 
                  <span class="body-2">Total: {{monitorsList.length}}</span>
                  <button type="button" class="btn btn-sm modal-outline-button waves-effect waves-light m-0" (click)="onCreateMonitor()">Create New Audience Monitor</button>
                </div>
                <div class="divider mb-2"></div>
                <mdb-tabs class="sam-tabs">
                  <mdb-tab title="Active">
                    <ul class="list-group list-group-light" style="max-height: 400px; overflow:scroll;">
                      @for(monitor of monitorsActiveList; track monitor) {
                        <li class="list-group-item monitor-item p-2 d-flex flex-row align-items-center">
                          <div class="monitor-item__number">{{ $index + 1 }}.</div>
                          <img alt="monitor image" class="monitor-item__image" [src]="getImage(monitor.imageUrl)">
                          <div class="monitor-item_container">
                              <div class="monitor-item__name mb-1">{{monitor.name}}</div>
                              <div class="monitor-item__goal mb-1"><span class="grey-text">Goal: </span>{{getAmountDisplay(monitor.goal)}}</div>
                              <div class="monitor-item__start mb-1"><span class="grey-text">Start at: </span>{{getAmountDisplay(monitor.startAt)}}</div>
                          </div>
                          <div class="d-flex flex-row ml-auto">
                            <a class="btn btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 mr-2"  [href]="monitor.url" target="_blank" 
                              style="border: 1px solid rgba(0, 0, 0, 0.08); width: 36px; height: 36px; box-shadow: none;">
                              <i class="fas blue-text fa-external-link-alt"></i>
                            </a>
                            <button class="btn btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 mr-2" (click)="editMonitor(monitor)" 
                              style="border: 1px solid rgba(0, 0, 0, 0.08); width: 36px; height: 36px; box-shadow: none;">
                              <i class="fas fa-pencil-alt p2p-popover-icon d-flex align-items-center cursor--pointer"></i>
                            </button>
                            <button class="btn btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 mr-2" (click)="onDeleteMonitorClick(monitor)" 
                              style="border: 1px solid rgba(0, 0, 0, 0.08); width: 36px; height: 36px; box-shadow: none;">
                              <i class="black-text far fa-trash-alt p2p-popover-icon cursor--pointer"></i>
                            </button>
                          </div>
                        </li>
                      }
                    </ul>
                  </mdb-tab>
                  <mdb-tab title="Inactive">
                    <ul class="list-group list-group-light" style="max-height: 400px; overflow:scroll;">
                      @for(monitor of monitorsInActiveList; track monitor) {
                        <li class="list-group-item monitor-item p-2 d-flex flex-row align-items-center">
                          <div class="monitor-item__number">{{ $index + 1 }}.</div>
                          <img alt="monitor image" class="monitor-item__image" [src]="getImage(monitor.imageUrl)">
                          <div class="monitor-item_container">
                              <div class="monitor-item__name mb-1">{{monitor.name}}</div>
                              <div class="monitor-item__goal mb-1"><span class="grey-text">Goal: </span>{{getAmountDisplay(monitor.goal)}}</div>
                              <div class="monitor-item__start mb-1"><span class="grey-text">Start at: </span>{{getAmountDisplay(monitor.startAt)}}</div>
                          </div>
                          <div class="d-flex flex-row ml-auto">
                            <button class="btn btn--table-action d-flex align-items-center justify-content-center px-2 p-0 my-0 ml-0 mr-2" (click)="onDeleteMonitorClick(monitor,true)" 
                              style="border: 1px solid rgba(0, 0, 0, 0.08); height: 36px; font-size: 12px!important; box-shadow: none;">
                              Activate
                            </button>
                            <a class="btn btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 mr-2"  [href]="monitor.url" target="_blank" 
                              style="border: 1px solid rgba(0, 0, 0, 0.08); width: 36px; height: 36px; box-shadow: none;">
                              <i class="fas blue-text fa-external-link-alt"></i>
                            </a>
                            <button class="btn btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 mr-2" (click)="editMonitor(monitor)" 
                              style="border: 1px solid rgba(0, 0, 0, 0.08); width: 36px; height: 36px; box-shadow: none;">
                              <i class="fas fa-pencil-alt p2p-popover-icon d-flex align-items-center cursor--pointer"></i>
                            </button>
                          </div>
                        </li>
                      }
                    </ul>
                  </mdb-tab>
                </mdb-tabs>
              </ng-container>
          }

          @if(activeScreen != 'monitorsList'){
            <div style="height: 520px;">
              <div class="d-flex flex-column mb-3">
                <div class="row d-flex justify-content-between" style="border-bottom: 1px solid #DFDFDF;">
                  <div class="col-7 pt-4">
                    <mdb-form-control class="form-fill" >
                      <app-mdbp-input mdbInput formControlName="name"  label='Name'></app-mdbp-input>
                    </mdb-form-control>
                    <ng-container *ngIf="campaigns$| async as campaigns">
                      <mdb-form-control class="form-fill">
                        <mdb-select [multiple]="true"  [filter]="true" class="mdb-select" formControlName="campaignIds">
                          <mdb-option class="option--multiple" value="all">Select All</mdb-option>
                          <mdb-option class="option--multiple" *ngFor="let camp of campaigns" [value]="camp.id">{{
                            camp.name
                          }}</mdb-option>
                        </mdb-select>
                        @if(!audianceMonitor.controls.campaignIds.valid && audianceMonitor.controls.campaignIds.touched){<span class="form-fill-error">Please select campaign.</span>}
                        <label mdbLabel class="form-label form-label--paybee">Select Linked Campaign(s)</label>
                      </mdb-form-control>
                    </ng-container>
                    <span class="subtitle-1 mb-1 d-block">Progress Bar Settings</span>
                  </div>
                  <div class="col-4 p-0 mr-2">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <div class="body-1 mr-1 ">Image</div>
                    </div> 
                    <div class="image-block mb-1 position-relative" style="height: 125px;">
                        <div
                            *ngIf="audianceMonitor.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                            class="image-block__file-container d-flex align-items-center justify-content-center"
                        >
                            <app-input-file formControlName="imageFile" [classes]="['btn--paybee-custom']" class="position-absolute" accept="image/png,image/jpeg" label="Upload"></app-input-file>
                        </div>
                        <div
                            *ngIf="audianceMonitor.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                            class="image-block__file-container d-flex align-items-start justify-content-end"
                        >
                            <app-icon-delete (click)="resetImage()" class="position-absolute cursor--pointer m-2"></app-icon-delete>
                        </div>
                        <img class="image-block__image" [src]="audianceMonitor.controls.imageDataUrl.value" style="width:100%;border-radius: 5px;">
                    </div>
                    <div class="d-flex justify-content-center flex-column">
                        @if(audianceMonitor.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                           <span class="blue-text body-2 text-center">OR</span>
                            <a (click)="openChooseImageModal()" class="blue-text body-2 text-center">Choose from previously used images</a>
                        }
                    </div>
                  </div>
                </div>
                <div class="row pt-1">
                  <div class="col-7">
                    <app-mdb-switch formControlName="hideGoalProgress" label="Hide Progress Bar"></app-mdb-switch>
                    <mdb-form-control class="form-fill" data-panel="settings" >
                      <app-mdbp-input mdbInput formControlName="goal" data-panel="settings" [isCurrencyMask]="true" label='Progress Bar Goal'>
                          <input  #inputNameC currencyMask formControlName="goal" class="form-control form-control--paybee"/>
                      </app-mdbp-input>
                    </mdb-form-control>
                    <mdb-form-control class="form-fill" data-panel="settings" >
                      <app-mdbp-input mdbInput formControlName="startAt" data-panel="settings" [isCurrencyMask]="true" label='Progress Bar Starting Amount'>
                          <input  #inputNameC currencyMask formControlName="startAt" class="form-control form-control--paybee"/>
                      </app-mdbp-input>
                    </mdb-form-control>
                    <div class="row d-flex justify-content-between ml-1 mb-2">
                      <label for="goalProgessBackgroundColor">Goal Progess Background Color</label>
                      <input type="color" class="form-control form-control-color" formControlName="goalProgessBackgroundColor" id="goalProgessBackgroundColor">
                    </div>
                    <div class="row d-flex justify-content-between ml-1">
                      <label for="goalProgessColor">Goal Progess Color</label>
                      <input type="color" class="form-control form-control-color" formControlName="goalProgessColor" id="goalProgessColor">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="modal-footer paybee-modal-footer">
          @if(activeScreen == 'monitorsList'){
            <button type="button" class="btn btn--paybee btn--cancel btn--md text-center ml-auto" style="width: 140px;" (click)="close()">Close</button>
          }
          <div class="d-flex flex-row justify-content-end">
            @if(activeScreen == 'createMonitor'){
              <button type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light m-0 mr-2" (click)="activeScreen = 'monitorsList'">Back</button>
              <button type="button" class="btn btn-sm modal-confirm-button waves-effect waves-light m-0" (click)="onClickCreateOrUpdate('create')">Create</button>  
            }
            @if(activeScreen == 'updateMonitor'){
              <button type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light m-0 mr-2" (click)="activeScreen = 'monitorsList'">Back</button>
              <button type="button" class="btn btn-sm modal-confirm-button waves-effect waves-light m-0" (click)="onClickCreateOrUpdate('update')">Update</button>  
            }

          </div>
        </div> 
    </ng-container> 